var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-email"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t(_vm.label)))]),_c('div',{staticClass:"control"},[_c('input',{attrs:{"type":"email"},domProps:{"value":_vm.value},on:{"input":_vm.input}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }